module.exports = __webpack_public_path__ + "static/img/dDR3.3b058f98.png";